export const getSyncStore = state => state.global.syncStore;
export const getSyncStoreCurrConfig = state =>
  state.global.syncStore.currConfig;
export const getSyncStoreUser = state => state.global.syncStore.user;

export const getUser = state => state.global.user;
export const getConfig = state => state.global.config;

export const getTheme = state => state.global.theme;
export const getRouterLocation = state => state.router.location;
